import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { HelmetProvider } from 'react-helmet-async';
import { store } from 'app/providers/store';
import { queryClient } from 'app/providers/queryClient';
import { initTheme, syncSystemTheme } from 'app/providers/themeSlice';
import { ErrorBoundary } from 'components/feedback/ErrorBoundary';

import { AuthInitializer } from 'features/auth/components/AuthInitializer';

interface AppProvidersProps {
  children: React.ReactNode;
}

function ThemeInitializer({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    store.dispatch(initTheme());

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const onSystemThemeChange = () => {
      store.dispatch(syncSystemTheme());
    };

    media.addEventListener('change', onSystemThemeChange);
    return () => media.removeEventListener('change', onSystemThemeChange);
  }, []);
  return <>{children}</>;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <ThemeInitializer>
            <AuthInitializer>
              <ErrorBoundary>{children}</ErrorBoundary>
            </AuthInitializer>
          </ThemeInitializer>
        </HelmetProvider>
      </QueryClientProvider>
    </Provider>
  );
}
